import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../lib/constants';

// Home (`/`, the OIDC return target) redirects to the chat-first landing surface
// (DEV-16971). Was `/inbox` before the chat-first direction; `/inbox` before
// that was `/workflows`.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: routes.CHAT });
  },
});
